<script setup>
  import { computed } from 'vue';
  import { isToday, isTomorrow, isYesterday, isPast } from 'date-fns';
  import ProForecastSpotForecasts from '@/components/ProForecastSpotForecasts.vue';

  const emit = defineEmits(['accordian:toggle', 'state:change', 'settings:change']);

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    forecaster: {
      type: Object,
      required: true  
    },
    showDailyForecast: {
      type: Boolean,
      default: true
    },
    spotForecastState: {
      type: Object,
      required: false
    },
    spotForecastStateLoading: {
      type: Boolean,
      default: false
    },
    spotForecastSettings: {
      type: Object,
      default: null
    }
  });

  const forecastDateHeader = computed(() => {
    if (props.proForecast.is_sample_forecast) return "Today's Forecast"
    
    const date = new Date(props.proForecast.valid_time_local_formatted);

    if (isToday(date)) {
      return "Today's Forecast";
    } else if (isTomorrow(date)) {
      return "Tomorrow's Forecast";
    } else if (isYesterday(date)) {
      return "Yesterdays's Forecast";
    } else if (isPast(date)) {
      return "Previous Forecast";
    } else {
      return "Upcoming Forecast";
    }
  });

  const forecastText = computed(() => {
    return props.proForecast.forecast
      .replace(/\n/g, '<br>')
      .replace(/\*/g, "<span class='bullet'>&nbsp;&bull;&nbsp;</span>");
  });

  const handleAccordianToggle = (e) => {
    emit('accordian:toggle', e);
  }

  const handleStateChange = (data) => {
    emit('state:change', data);
  }

  const handleSettingsChange = (data) => {
    emit('settings:change', data);
  }

</script>

<template>
  <div class="jwx-pro-forecast__body">
    <section class="jwx-page__section">
      <div class="jwx-page__section-header">
        <h3 class="jwx-page__section-title">{{ forecastDateHeader }}</h3>
        <p class="jwx-page__section-subhead">{{ props.proForecast.valid_time_local_formatted }}</p>
      </div>
      <div class="jwx-pro-forecast__block jwx-block">
        <div
          class="jwx-block__body-content jwx-pro-forecast__text" 
          data-preformatted-text="true"
          v-html="forecastText"
        >
        </div>
      </div>
    </section>
    <ProForecastSpotForecasts
      :spotForecasts="props.proForecast.spot_forecasts"
      :spotForecastSettings="props.spotForecastSettings"
      :forecaster="props.forecaster"
      :validDate="props.proForecast.valid_time_local_formatted"
      :showDailyForecast="props.showDailyForecast"
      :isSample="props.proForecast.is_sample_forecast"
      :spotForecastState="props.spotForecastState"
      :spotForecastStateLoading="props.spotForecastStateLoading"
      @accordian:toggle="handleAccordianToggle"
      @settings:change="handleSettingsChange"
      @state:change="handleStateChange"
    />
  </div>
</template>